import { Stack } from '@mui/material';
import dayjs from 'dayjs';

import {
	ESubscriptionStatus,
	ISubscriptionTicket,
	TSubscription,
} from '@mopla/data-models';

import { DTicketCard } from './DTicketCard';

interface IDTicketCardSectionWrapperProps {
	subscription: TSubscription;
	tickets: ISubscriptionTicket[];
}

export const DTicketCardSectionWrapper = ({
	subscription,
	tickets,
}: IDTicketCardSectionWrapperProps) => {
	// If tickets array contains any tickets - sort (by validFrom date) and render them by map
	if (tickets.length > 0) {
		return (
			<Stack alignItems="center" sx={{ width: '100%', gap: 5 }}>
				{tickets
					.sort((a, b) => (dayjs(a.validFrom).isBefore(b.validFrom) ? -1 : 1))
					.map((ticket) => (
						<DTicketCard
							key={ticket.id}
							subscription={subscription}
							ticket={ticket}
						/>
					))}
			</Stack>
		);
	}

	// No tickets but subscription is preordered, paused or invalid - render DTicketCard without ticket
	if (
		subscription?.status === ESubscriptionStatus.PREORDERED ||
		subscription?.status === ESubscriptionStatus.PAUSED ||
		subscription?.status === ESubscriptionStatus.INVALID
	) {
		return (
			<Stack alignItems="center" sx={{ width: '100%' }}>
				<DTicketCard subscription={subscription} />
			</Stack>
		);
	}
};
